import React from 'react';
import InstitucionalFrame from './InstitucionalFrame';

const InstitucionalTorneios: React.FC = () => (
  <InstitucionalFrame page="torneios.html" title="InPlay Sports — Torneios" />
);

export default InstitucionalTorneios;
